module.exports = __webpack_public_path__ + "static/media/who-logo-small.0fe8ca9d.svg";